module.exports = __webpack_public_path__ + "static/media/developer.1a521c8f.svg";